import React, { useEffect, useState } from "react";
import InvoiceLayout from "../layouts/InvoiceLayout";

const Invoice = () => {
  const [period, setPeriod] = useState("");

  useEffect(() => {
    const path = window.location.pathname;

    const periodFromUrl = decodeURIComponent(path.split("/invoice/")[1]);

    setPeriod(periodFromUrl);
  }, []);

  return (
    <div className="p-8 bg-gray-100">
      <InvoiceLayout date={period} />
    </div>
  );
};

export default Invoice;
